$(document).ready(function(){
           setTimeout( function () {
          var subscription_value = $('.subscription-radio .rc-radio__subscription').text();
              $('.onetime-radio .rc-radio__label').html('<strong>One-time purchase</strong>');
              $('.subscription-radio .rc-radio__subscription').html('<strong>'+subscription_value+'</strong>');
               $('.onetime-radio .rc-radio__label').after('<p class="u-h6 Guarantee__Text">No Subscription</p>');
               $('.subscription-radio .rc-radio__label').after('<p class="u-h6 Guarantee__Text">Pause & cancel anytime.</p>');
               var Product_price = $('.ProductOTP-Price').text();
              $('.onetime-radio .rc-radio__label').after('<span class="rc-radio__price_one"><strong>'+Product_price+'</strong></span>');
              var onetime_servingprice = $('.ontime-priceserving').text();
              $('.onetime-radio .Guarantee__Text').after('<p class="onetime_priceWrapper">($'+ onetime_servingprice +'/serving)</p>');
               var subscription_servingprice = $('.subscription-priceserving').text();
              $('.subscription-radio .Guarantee__Text').after('<p class="subscribe_priceWrapper">($'+ subscription_servingprice +'/serving)</p>');
              $('.rc-radio__label .rc-radio__price').after('<span class="Subscription__Price Subscription_ComparisionPrice Heading u-h6 FontWeight_Six"></span>');
             if ($('.onetime-radio span.rc-radio__price_one').length > 0) {
          	  document.querySelector('.Subscription__Price.Subscription_ComparisionPrice').textContent = document.querySelector('.onetime-radio span.rc-radio__price_one').textContent.trim();
             };
            $('.oke-w-mediaGridModule .oke-media--linked').removeAttr("role");
            $('.oke-mediaStrip-container.oke-w-mediaStrip').removeAttr("role");
            $('.oke-media--linked').removeAttr("role");
           $('.oke-w-reviews-list-item').each(function() {
             var negativeReview = $(this).find('.oke-helpful-vote-button--negative .oke-helpful-vote-counter').text();
             var positiveReview = $(this).find('.oke-helpful-vote-button--positive .oke-helpful-vote-counter').text();
            $(this).find('.oke-helpful-vote-button--negative').attr('aria-label', negativeReview);
            $(this).find('.oke-helpful-vote-button--positive').attr('aria-label', positiveReview);
           });
          }, 1600);
        });
        $(window).load(function(){
             var recommondedrating = $('.oke-w-header-content-module--left .oke-w-recommendsModule .oke-w-recommendsModule-value').html();
            console.log(recommondedrating);
            var Rating_value = $('.oke-w-header-content-module--left .oke-w-ratingAverageModule .oke-w-ratingAverageModule-rating  .oke-w-ratingAverageModule-rating-average').html();
        setTimeout( function () {
         $('.oke-w-recommendsModule .oke-w-recommendsModule-value').remove();
         $('.oke-w-recommendsModule .oke-w-recommendsModule-text').before('<span class="oke-w-recommendsModule-value"><strong>'+ recommondedrating +'</strong></span>');
        $('.oke-w-selectAttr-item-title').remove();
         $('.oke-w-reviews-list-item .oke-w-selectAttr-item-value').before('<span class="oke-w-selectAttr-item-title"><strong>I DRINK PIQUE FOR</strong></span>');
           $('.oke-w-ratingAverageModule .oke-w-ratingAverageModule-rating  .oke-w-ratingAverageModule-rating-average').remove();
          $('.oke-w-ratingAverageModule .oke-w-ratingAverageModule-rating  .oke-w-ratingAverageModule-rating-stars').before('<span class="oke-w-ratingAverageModule-rating-average"><strong>'+ Rating_value +'</strong></span>');
        },500);
        })

document.addEventListener("DOMContentLoaded", function () {

  const tabs = document.querySelectorAll(".pt_456_tabs");
  const panels = document.querySelectorAll(".ProductIngre_TabPanel");

  // Default: show first panel
  panels.forEach((panel, index) => {
    panel.classList.toggle("visible", index === 0);
  });

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", function () {

      // Remove active class from all tabs
      tabs.forEach(t => t.classList.remove("pt_456_tabs_active"));

      // Add active class to clicked tab
      this.classList.add("pt_456_tabs_active");
      this.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });

      // Show only the matching panel
      panels.forEach((panel, i) => {
        panel.classList.toggle("visible", i === index);
      });

    });
  });

});